import { useInView } from 'react-intersection-observer'
import styled from 'styled-components'

import { ChertoExperiments } from 'constants/experiments'
import useExperiment from 'hooks/Experiments/useExperiment'

import OfferPropertySurroundings from './OfferPropertySurroundings'

interface Props {
  offerId: string
  latitude: number
  longitude: number
}

const ActivationSentinel = styled.div`
  height: 1px;
  width: 100%;
  pointer-events: none;
`

function OfferPropertySurroundingsHideExperiment({
  offerId,
  latitude,
  longitude,
}: Props) {
  const [activationRef, inView] = useInView({
    triggerOnce: true,
  })
  const { isAnyVariant: shouldHideNearbyPlaces } = useExperiment(
    ChertoExperiments.croHideNearbyGooglePlaces,
    { canActivate: inView },
  )

  return <>
    <ActivationSentinel
      ref={activationRef}
      aria-hidden="true"
      data-testid="offer-property-surroundings-hide-experiment-activation-sentinel"
    />
    {!shouldHideNearbyPlaces && (
      <OfferPropertySurroundings
        offerId={offerId}
        latitude={latitude}
        longitude={longitude}
      />
    )}
  </>
}

export default OfferPropertySurroundingsHideExperiment
